import { Route, useHistory } from 'react-router-dom';
import { ToggleTabs, ToggleTabsButtonsContainer } from '../ToggleTabs';
export function PageTabs(props) {
    const { baseUrl, children } = props;
    const history = useHistory();
    const handleSelect = (path) => {
        history.push(`${baseUrl}/${path}`);
    };
    return (<Route path={`${baseUrl}/:path`} render={({ match }) => (<ToggleTabs activeTab={match.params.path} onSelectTab={handleSelect}>
          <ToggleTabsButtonsContainer size="small">{children}</ToggleTabsButtonsContainer>
        </ToggleTabs>)}/>);
}
